<template>
  <el-row :gutter="10">
    <el-col
      :span="config.span"
      v-for="config in searchConfig.list"
      :key="config.model || config.type"
    >
      <el-date-picker
        size="medium"
        v-if="config.type === 'date'"
        v-model="info[config.model]"
        type="daterange"
        align="left"
        :editable="false"
        unlink-panels
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="
          getPickerOptions(config.setting?.pickerOptions, config.type)
        "
        value-format="timestamp"
        :default-time="['00:00:00', '23:59:59']"
        style="width: 100%"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="config.type === 'singleDate'"
        size="medium"
        v-model="info[config.model]"
        type="date"
        placeholder="选择日期"
        :editable="false"
        :picker-options="
          getPickerOptions(config.setting?.pickerOptions, config.type)
        "
        value-format="timestamp"
      >
      </el-date-picker>
      <el-input
        size="medium"
        v-else-if="config.type === 'input'"
        v-model="info[config.model]"
        :placeholder="config.placeholder"
      ></el-input>
      <el-select
        size="medium"
        v-else-if="config.type === 'select'"
        v-model="info[config.model]"
        :placeholder="config.placeholder"
        :multiple="config.setting?.multiple ?? false"
        collapse-tags
      >
        <el-option
          size="medium"
          v-for="item in config.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-row v-else-if="config.type === 'button'" type="flex" justify="start">
        <el-button
          size="medium"
          :type="item.style"
          v-for="item in config.operation"
          :key="item.type"
          @click="operation(item.listeners)"
          >{{ item.label }}</el-button
        >
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { getLATime, getTimeRange } from "@/utils/time.js";

export default {
  props: {
    searchConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      info: {},
      defaultShortcuts: [
        {
          text: "最近一周",
          onClick(picker) {
            return getTimeRange(picker, 24 * 7);
          },
        },
        {
          text: "最近一个月",
          onClick(picker) {
            return getTimeRange(picker, 24 * 30);
          },
        },
        {
          text: "最近三个月",
          onClick(picker) {
            return getTimeRange(picker, 24 * 90);
          },
        },
      ],
    };
  },
  methods: {
    getLATime,
    getPickerOptions(data, type) {
      let baseConfig = {
        disabledDate(time) {
          if (data && data.disabledDate) {
            return time.getTime() >= data.disabledDate;
          }
          return false;
        },
        cellClassName: data?.cellClassName ? data?.cellClassName : () => {},
        onPick: data?.onPick ? data?.onPick : () => {},
      };
      return type === "date"
        ? {
            ...baseConfig,
            shortcuts: data?.shortcuts
              ? data?.shortcuts
              : this.defaultShortcuts,
          }
        : baseConfig;
    },
    operation(event) {
      this.$listeners[event](this.info);
    },
    setDataInfo(key, value) {
      this.$set(this.info, key, value);
    },
  },
};
</script>

<style lang="less">
.el-date-table td.la-time-default span {
  color: black;
}

.el-date-table td.next-month.la-time-default span,
.el-date-table td.prev-month.la-time-default span {
  color: #c0c4cc !important;
}

.el-date-table td.end-date.la-time-default span,
.el-date-table td.start-date.la-time-default span {
  color: white !important;
}

.el-date-table td.end-date.la-time-today span,
.el-date-table td.start-date.la-time-today span {
  color: white !important;
}

.el-date-table td.today.la-time-default span {
  color: black;
  font-weight: normal;
}

.el-date-table td.disabled.la-time-default span {
  color: #c0c4cc;
}

.el-date-table td.la-time-today span {
  color: #409eff;
  font-weight: 700;
}
</style>
